import { Environment } from './environment-type';

export const environment: Environment = {
  firebase: {
    apiKey: 'AIzaSyC0Gxz1-QanK5xMvpF6FqDLLQToxqKJ96g',
    authDomain: 'hallo-horeca.firebaseapp.com',
    projectId: 'hallo-horeca',
    storageBucket: 'hallo-horeca.firebasestorage.app',
    messagingSenderId: '193849315459',
    appId: '1:193849315459:web:fbc954bda01523fe5dcbb6',
    measurementId: 'G-N5RXFHSQ2H',
  },
  useEmulators: false,
  production: true,
  googleMapId: '2f66caed719a7321dbd628d5',
  defaultImageUrl: 'https://storage.googleapis.com/hallo-horeca/categories/cafe.jpg',
  swCheckTime: 300,
};
